import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import {EntityInvestmentViewModel} from '../view-models/entity-investment.view-model';

@Component({
    selector: 'app-entity-investment-card',
    templateUrl: './entity-investment-card.component.html',
    styleUrls: ['./entity-investment-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EntityInvestmentCardComponent {
    public readonly entityInvestment = input.required<EntityInvestmentViewModel>();
    public readonly cardClicked = output<EntityInvestmentViewModel>();

    handleClick(_event: Event): void {
        this.cardClicked.emit(this.entityInvestment());
    }
}
